import { id } from "date-fns/esm/locale";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as IconCloseLight } from "../../../asserts/imgs/chart/fubon/close_24px_rounded_light.svg";
import common from "../../../asserts/js/common";

export const UO = (props) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [period, setPeriod] = useState(7);
  const [period2, setPeriod2] = useState(14);
  const [period3, setPeriod3] = useState(28);
  const [color, setColor] = useState("AA2211");
  const [thickness, setThickness] = useState(2);
  const [style, setStyle] = useState("s");
  const [showTracker, setShowTracker] = useState(true);

  const [buy, setBuy] = useState(30);
  const [sale, setSale] = useState(70);
  const [height, setHeight] = useState("1");
  const [value, setValue] = useState(period + "," + period2 + "," + period3);

  const [localChartSetting, setLocalChartSetting] = useState(null)

  useEffect(() => {
    let localSetting = common.getlocalChartStorage();

    if (localSetting)
      setLocalChartSetting(localSetting.UO_Option)
  }, []);

  useEffect(() => {
    if (localChartSetting) {
      try {
        const UO = localChartSetting.option;

        setValue(UO.period + "," + UO.period2 + "," + UO.period3);
        props.onTAValueChange({
          ta: "UO",
          name: `${t("chart5.TA.UO")} (UO)`,
          option: {
            period: UO.period,
            period2: UO.period2,
            period3: UO.period3,
            color: UO.color,
            thickness: UO.thickness,
            style: UO.style,
            showTracker: UO.showTracker,
            buy: UO.buy,
            sale: UO.sale,
            height: UO.height,
          },
          value: localChartSetting.value,
        });
      } catch { }
    }
  }, [localChartSetting]);

  useEffect(() => {
    const UO = props.localChartSetting.UO_Option.option;

    setColor(UO.color);
    setPeriod(parseInt(UO.period) || period);
    setPeriod2(parseInt(UO.period2) || period2);
    setPeriod3(parseInt(UO.period3) || period3);
    setThickness(parseInt(UO.thickness) || thickness);
    setStyle(UO.style);
    setShowTracker(UO.showTracker);

    setBuy(parseInt(UO.buy) || buy);
    setSale(parseInt(UO.sale) || sale);

    setHeight(UO.height);

  }, [props.localChartSetting]);

  useEffect(() => {
    setValue(period + "," + period2 + "," + period3);
    props.onTAValueChange({
      ta: "UO",
      name: `${t("chart5.TA.UO")} (UO)`,
      option: {
        period: period,
        period2: period2,
        period3: period3,
        color: color,
        thickness: thickness,
        style: style,
        showTracker: showTracker,
        buy: buy,
        sale: sale,
        height: height,
      },
      value: value,
    });
  }, [
    period,
    period2,
    period3,
    color,
    thickness,
    style,
    showTracker,
    buy,
    sale,
    height,
  ]);

  useEffect(() => {
    setTAColor();
  }, [props.selectedColor]);

  useEffect(() => {
    setIsOpen(props.isOpen);
  }, [props.isOpen]);

  useEffect(() => {
    const UO = props.localChartSetting.UO_Option.option;

    setColor(UO.color);
    setPeriod(parseInt(UO.period) || period);
    setPeriod2(parseInt(UO.period2) || period2);
    setPeriod3(parseInt(UO.period3) || period3);
    setThickness(parseInt(UO.thickness) || thickness);
    setStyle(UO.style);
    setShowTracker(UO.showTracker);

    setBuy(parseInt(UO.buy) || buy);
    setSale(parseInt(UO.sale) || sale);

    setHeight(UO.height);
  }, [props.isReset]);

  const resetALL = () => {
    setColor("AA2211");
    setPeriod(7);
    setPeriod2(14);
    setPeriod3(28);
    setThickness(2);
    setStyle("s");
    setShowTracker(true);

    setBuy(30);
    setSale(70);
  };

  const onResetClick = () => {
    const answer = window.confirm(t("chart5.alertMsg"));
    if (answer) {
      setIsOpen(true);
      resetALL();
    } else {
      setIsOpen(true);
    }
  };

  const openOptionBox = (e) => {
    try {
      if (
        e.target.className.replace(" focus-within", "") ===
        "menusubitem msiaction techicalindicator" ||
        e.target.className.replace(" focus-within", "") === "span" ||
        e.target.className.replace(" focus-within", "") === "optboxarrow" ||
        e.target.className.replace(" focus-within", "") === "msiicon"
      ) {
        if (e.target.className.replace(" focus-within", "") !== "b2dbtn") {
          if (isOpen) setIsOpen(false);
          else setIsOpen(true);
        }
      }
    } catch (err) { }
  };

  // id: string
  const removeTA = (id) => {
    props.removeTA(id);
  };

  // e: any, type: string
  const onPeriodChange = (e, type) => {
    if (type === "p1") {
      setPeriod(e.target.value);
    } else if (type === "p2") {
      setPeriod2(e.target.value);
    } else {
      setPeriod3(e.target.value);
    }
  };

  const onThicknessChange = (e) => {
    setThickness(e.target.value);
  };

  const onStyleChange = (e) => {
    setStyle(e.target.value);
  };

  const onHeightChange = (e) => {
    setHeight(e.target.value);
  };

  const onShowTracker = () => {
    if (showTracker) setShowTracker(false);
    else setShowTracker(true);
  };

  // e: any, type: string
  const onValueChange = (e, type) => {
    if (type === "buy") setBuy(e.target.value);
    else setSale(e.target.value);
  };

  const setTAColor = () => {
    switch (props.source) {
      case "UO":
        setColor(props.selectedColor);
        break;
    }
  };

  const onColorClick = () => {
    props.onColorClick(color, "UO", t("chart5.setting"));
  };

  const onKeyDown = (evt) => {
    if (evt.key === "-") evt.preventDefault();
  };

  return (
    <div
      className="menusubitem msiaction techicalindicator"
      id="msi-ta"
      onClick={(e) => openOptionBox(e)}
    >
      {/* <div className="msiicon" onClick={() => removeTA("UO")}></div> */}
      <div className="box-container">
        <span className="span">
          {t("chart5.TA.UO")} (UO) {value}
        </span>
        <IconCloseLight className="close-icon" onClick={() => removeTA("UO")} />
      </div>
      <div
        className="optboxarrow"
        style={isOpen ? { transform: "rotate(180deg)" } : {}}
        onClick={(e) => openOptionBox(e)}
      ></div>
      <div
        className="b2dbtn"
        style={isOpen ? { display: "flex" } : {}}
        title="スタイル設定を初期設定に戻す"
        onClick={onResetClick}
      ></div>
      <div className="msi-optbox" style={isOpen ? {} : { display: "none" }}>
        <div className="menusubitem " id="msi-ta-UO">
          <div className="flexbox">
            <div className="taparamlbl">{t("chart5.period")}</div>

            <div className="inputbox taparam">
              <input
                type="number"
                step="1"
                min="1"
                value={period}
                maxLength={4}
                style={{ width: "30px" }}
                onChange={(e) => onPeriodChange(e, "p1")}
                onKeyDown={onKeyDown}
              />
            </div>

            <div className="inputbox taparam">
              <input
                type="number"
                step="1"
                min="1"
                value={period2}
                maxLength={4}
                style={{ width: "30px" }}
                onChange={(e) => onPeriodChange(e, "p2")}
                onKeyDown={onKeyDown}
              />
            </div>

            <div className="inputbox taparam">
              <input
                type="number"
                step="1"
                min="1"
                value={period3}
                maxLength={4}
                style={{ width: "30px" }}
                onChange={(e) => onPeriodChange(e, "p3")}
                onKeyDown={onKeyDown}
              />
            </div>
          </div>

          <div className="menusubitem stylebox ">
            <div className="styleboxlbl">{t("chart5.setting")}</div>
            <button
              id="msi-ta-UI-p0-color0"
              className="colorpicker"
              value={color}
              style={{ backgroundColor: "#" + color }}
              onClick={onColorClick}
            ></button>
            <div className="inputbox">
              <input
                id="msi-ta-UI-p0-thickness"
                type="number"
                step="1"
                min="1"
                max="9"
                value={thickness}
                maxLength={1}
                style={{ width: "30px" }}
                onChange={(e) => onThicknessChange(e)}
              />
            </div>
            <div className="selectbox" onChange={(e) => onStyleChange(e)}>
              <select id="msi-ta-UI-p0-style" value={style}>
                <option value="s">{t("chart5.realLine")}</option>
                <option value="d">{t("chart5.dotLine")}</option>
              </select>
            </div>
            <div className="showtracker">
              <div
                id="msi-ta-UI-p0-showtracker"
                className={
                  showTracker ? "checkboxbutton-selected" : "checkboxbutton"
                }
                onClick={onShowTracker}
              ></div>
              <div className="styleboxlbl">{t("chart5.showValue")}</div>
            </div>
          </div>
        </div>

        <div className="floatmsibox" style={{ display: "flex" }}>
          <div className="menusubitem">
            <div className="taparamlbl">
              {t("chart5.buy")} {t("chart5.signal")}
            </div>
            <div className="inputbox taparam">
              <input
                type="number"
                step="1"
                min="0"
                max="100"
                value={buy}
                maxLength={4}
                style={{ width: "30px" }}
                onChange={(e) => onValueChange(e, "buy")}
              />
            </div>
          </div>
          <div className="menusubitem">
            <div className="taparamlbl">
              {t("chart5.sell")} {t("chart5.signal")}
            </div>
            <div className="inputbox taparam">
              <input
                type="number"
                step="1"
                min="0"
                max="100"
                value={sale}
                maxLength={4}
                style={{ width: "30px" }}
                onChange={(e) => onValueChange(e, "sale")}
              />
            </div>
          </div>
        </div>

        <div className="menusubitem">
          <div className="flexbox">
            <div className="taparamlbl">{t("chart5.displayScreenSize")}</div>
            <div className="selectbox taparam">
              <select defaultValue="1" onChange={(e) => onHeightChange(e)} value={height}>
                <option value="2">{t("chart5.large")}</option>
                <option value="1">{t("chart5.normal")}</option>
                <option value="0">{t("chart5.small")}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
